jQuery(document).on( 'ready', function(){
  jQuery('.privacy-policy-link').attr( 'target', '_blank' );
  jQuery( 'input[type="submit"]' ).each( function () {
    var $input = jQuery( this );
    var $button = jQuery( '<button type="submit">' + $input.val() + '</button>' );
    jQuery.each( $input[0].attributes, function () {
      $button.attr( this.name, this.value );
    });
    $input.replaceWith( $button );
  });
  jQuery('.message,.notice,.success').on('click', function(){
    jQuery(this).remove();
  });
});
